import { useEffect } from "react";

interface OpenGraphTagsProps {
  title: string;
  description: string;
  image: string;
  url: string;
  type?: string;
  siteName?: string;
}

export function OpenGraphTags({
  title,
  description,
  image,
  url,
  type = "article",
  siteName = "Danis Painting Co."
}: OpenGraphTagsProps) {
  useEffect(() => {
    // Remove existing Open Graph and Twitter Card meta tags
    const existingOgTags = document.querySelectorAll('meta[property^="og:"], meta[name^="twitter:"]');
    existingOgTags.forEach(tag => tag.remove());

    // Create Open Graph meta tags
    const ogTags = [
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:image", content: image },
      { property: "og:url", content: url },
      { property: "og:type", content: type },
      { property: "og:site_name", content: siteName },
    ];

    // Create Twitter Card meta tags
    const twitterTags = [
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: description },
      { name: "twitter:image", content: image },
    ];

    // Append Open Graph tags to head
    ogTags.forEach(({ property, content }) => {
      const meta = document.createElement("meta");
      meta.setAttribute("property", property);
      meta.setAttribute("content", content);
      document.head.appendChild(meta);
    });

    // Append Twitter Card tags to head
    twitterTags.forEach(({ name, content }) => {
      const meta = document.createElement("meta");
      meta.setAttribute("name", name);
      meta.setAttribute("content", content);
      document.head.appendChild(meta);
    });

    // Cleanup function to remove tags when component unmounts
    return () => {
      const allSocialTags = document.querySelectorAll('meta[property^="og:"], meta[name^="twitter:"]');
      allSocialTags.forEach(tag => tag.remove());
    };
  }, [title, description, image, url, type, siteName]);

  return null; // This component doesn't render anything visible
}
